import axios from 'axios'

export default {
  getOrders ( params, callback ) {
    axios.get('/orders', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getOrder ( orderId, callback, fallback ) {
    axios.get('/orders/' + orderId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/orders', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( orderId, data, callback, fallback ) {
    axios.post( '/orders/' + orderId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  clone ( data, callback, fallback ) {
    axios.post( '/orders/' + data.id + '/clone', data)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( orderId, callback, fallback ) {
    axios.delete( '/orders/' + orderId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getItems ( orderId, params, callback ) {
    axios.get('/orders/' + orderId + '/items', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  createItem ( orderId, data, callback, fallback ) {
    axios.post( '/orders/' + orderId + '/items', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  saveItem ( orderId, itemId, data, callback, fallback ) {
    axios.post( '/orders/' + orderId + '/items/' + itemId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteItem ( orderId, itemId, callback, fallback ) {
    axios.delete( '/orders/' + orderId + '/items/' + itemId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  downloadPDF ( orderId, callback, fallback ) {
    axios({
      url: '/orders/' + orderId + '/pdf',
      method: 'GET',
      responseType: 'blob', // important
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  },
  printWIP ( params, callback, fallback ) {
    axios.get('/orders/wip', {
      responseType: 'blob', // important
      params
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  }
}
